<template>
  <v-dialog v-model="modalValue" scrollable max-width="700px">
    <v-card class="dialog_security_notice">
      <v-toolbar flat>
        <v-toolbar-title>Aviso de seguridad y privacidad</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <p>
          Aplicaciones Salud, S.L. informa de una situación de seguridad relacionada con la publicación por
          terceros de determinada documentación que podría contener información vinculada a prescripciones
          electrónicas.
        </p>

        <h3>¿Qué ha ocurrido?</h3>
        <p>
          El 25 de julio de 2026 recibimos una comunicación de un tercero que afirmaba haber accedido de forma
          no autorizada a nuestros sistemas y amenazaba con publicar información relacionada con pacientes y
          prescripciones electrónicas.
        </p>
        <p>
          Desde ese momento se iniciaron actuaciones de comprobación y seguridad. Posteriormente, tuvimos
          conocimiento de la existencia de una publicación en Internet relacionada con dicha información.
        </p>
        <p>
          A fecha de este aviso continúa en investigación el alcance de los hechos y no se ha determinado el
          origen de la información publicada ni el mecanismo por el que pudiera haber sido obtenida.
        </p>

        <h3>¿Qué información podría estar afectada?</h3>
        <p>
          La documentación publicada podría incluir datos identificativos y determinada información vinculada
          a prescripciones médicas, tratamientos o medicación.
        </p>
        <p>
          En este momento seguimos trabajando para determinar con precisión el alcance de la información y las
          personas que pudieran haberse visto afectadas.
        </p>

        <h3>Posibles consecuencias</h3>
        <p>
          La principal consecuencia identificada es una posible pérdida de confidencialidad de información
          personal y sanitaria incluida en la documentación publicada.
        </p>
        <p>
          Hasta el momento no tenemos constancia de que se hayan materializado otros perjuicios concretos para
          las personas potencialmente afectadas.
        </p>

        <h3>¿Qué medidas hemos adoptado?</h3>
        <p>Desde que tuvimos conocimiento de los hechos:</p>
        <ul>
          <li>se revisaron los registros técnicos disponibles;</li>
          <li>se encargó una auditoría extraordinaria de seguridad a una empresa especializada;</li>
          <li>los hechos fueron denunciados ante la Policía Nacional, con la que continuamos colaborando;</li>
          <li>se han adoptado medidas de refuerzo y mejora de seguridad;</li>
          <li>se ha realizado la correspondiente notificación a la Agencia Española de Protección de Datos;</li>
          <li>nuestro Delegado de Protección de Datos está coordinando las actuaciones derivadas del incidente.</li>
        </ul>
        <p>
          Con la información disponible actualmente, no hemos identificado ninguna actuación específica que
          deban realizar los usuarios como consecuencia de esta situación.
        </p>

        <h3>Más información</h3>
        <p>
          Para cualquier consulta relacionada con este incidente puedes dirigirte a nuestro Delegado de
          Protección de Datos a través de la dirección
          <a href="mailto:rgpd@docline.es">rgpd@docline.es</a>
        </p>
        <p>Continuaremos actualizando la información disponible si se producen novedades relevantes.</p>

        <p><strong>Fecha de publicación: 18 de agosto de 2026</strong></p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" text @click="close">{{ $t('common.close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SecurityNoticeModal',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    modalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },

  methods: {
    close() {
      this.$emit('input', false);
    },
  },
};
</script>

<style lang="scss">
.dialog_security_notice {
  max-height: 620px;

  .v-card__text {
    font-size: 13px;
    line-height: 1.4;
  }

  p {
    margin-bottom: 8px;
  }

  h3 {
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 2px;
  }

  ul {
    margin: 0 0 8px;
    padding-left: 20px;
  }
}
</style>
